module.exports = __webpack_public_path__ + "img/br.18730022.svg";